var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4286 52.0607V43.0676L61.7828 37.2193C62.4794 36.8185 62.9061 36.0933 62.9061 35.3103C62.9061 34.5274 62.4794 33.8022 61.7828 33.4014L51.4971 27.5862L61.7828 21.771C62.4822 21.3748 62.9119 20.6505 62.9119 19.8676C62.9119 19.0847 62.4822 18.3603 61.7828 17.9641L46.8 9.47862C46.0855 9.08136 45.2059 9.08136 44.4914 9.47862L35.4286 14.6097H28.5714L19.5086 9.47862C18.794 9.08136 17.9145 9.08136 17.2 9.47862L2.21713 17.9531C1.51643 18.351 1.08618 19.0772 1.08618 19.8621C1.08618 20.6469 1.51643 21.3732 2.21713 21.771L12.5028 27.5862L2.21713 33.4014C1.52058 33.8022 1.09388 34.5274 1.09388 35.3103C1.09388 36.0933 1.52058 36.8185 2.21713 37.2193L12.5714 43.0676V52.0607H51.4286Z",
    fill: "#FAC176"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4286 43.0676V52.0607C51.4261 52.8421 50.9957 53.564 50.2972 53.9586L33.1543 63.691C32.8065 63.8951 32.407 64.002 32 64L31.9429 64L32 63.2497V38.6207L44.4914 45.6938C45.206 46.0911 46.0855 46.0911 46.8 45.6938L51.4286 43.0676Z",
    fill: "#E57E25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 38.6207V63.2497L31.9428 64C31.5557 63.9896 31.1779 63.8832 30.8457 63.691L13.7028 53.9586C13.0043 53.564 12.5739 52.8421 12.5714 52.0607V43.0676L17.2 45.6938C17.9145 46.0911 18.794 46.0911 19.5086 45.6938L32 38.6207Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4972 27.5862L51.4286 27.6193L32 38.6207L12.5714 27.6193L12.5029 27.5862L28.5714 18.4938V30.8965C28.5714 31.506 29.0831 32 29.7143 32H34.2857C34.9169 32 35.4286 31.506 35.4286 30.8965V18.4938L51.4972 27.5862Z",
    fill: "#D25627"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1028 7.72412H35.4285V30.8965C35.4285 31.506 34.9169 32 34.2857 32H29.7143C29.0831 32 28.5714 31.506 28.5714 30.8965V7.72412H25.8971C25.4284 7.73322 25.004 7.45812 24.8352 7.03587C24.6664 6.61361 24.7893 6.13451 25.1428 5.83723L31.2457 0.264812C31.6821 -0.0880673 32.3178 -0.0880673 32.7543 0.264812L38.8571 5.83723C39.2106 6.13451 39.3336 6.61361 39.1648 7.03587C38.996 7.45812 38.5715 7.73322 38.1028 7.72412Z",
    fill: "#4FBA6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadership);
export default __webpack_public_path__ + "static/media/leadership.7824124ee3d95c1bee513c1678ca516b.svg";
export { ForwardRef as ReactComponent };